import { createStore } from 'owa-satcheljs';
import type SearchFolderState from './schema/SearchFolderViewState';

const searchFolderState: SearchFolderState = {
    isOpen: false,
    mailboxInfo: undefined,
    createSearchFolderModalEntryPoint: undefined,
    searchFolderEditState: {
        searchFolderId: '',
        searchFolderName: '',
        focusedClauseId: '',
        searchFolderType: undefined,
        searchFolderNameError: undefined,
        additionalData: null,
        isEditMode: false,
        inValidationState: false,
        existingSearchFolderNames: [],
    },
};

export const getStore: () => SearchFolderState = createStore<SearchFolderState>(
    'searchFolderState',
    searchFolderState
);
export default getStore;
